var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-menu code hidden highlight"},[_c('small',[_vm._v("(CRTL + ~) opens this menu")])])}]

export { render, staticRenderFns }